import { useState, useEffect } from 'react';

/**
 * 디바운스 훅
 * 입력값이 변경된 후 일정 시간이 지나면 값을 반환합니다.
 * 
 * @param value - 디바운스할 값
 * @param delay - 지연 시간 (밀리초, 기본값: 500ms)
 * @returns 디바운스된 값
 * 
 * @example
 * const [searchQuery, setSearchQuery] = useState('');
 * const debouncedSearchQuery = useDebounce(searchQuery, 500);
 * 
 * useEffect(() => {
 *   // debouncedSearchQuery가 변경될 때만 검색 실행
 *   performSearch(debouncedSearchQuery);
 * }, [debouncedSearchQuery]);
 */
export const useDebounce = <T,>(value: T, delay: number = 500): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

